export const theme = {
  colors: {
    primary: {
      normal: '#6e07b2',
    }
  }
}
